import { render, staticRenderFns } from "./RelatedSelect.vue?vue&type=template&id=21988fb0"
import script from "./RelatedSelect.vue?vue&type=script&lang=js"
export * from "./RelatedSelect.vue?vue&type=script&lang=js"
import style0 from "./RelatedSelect.vue?vue&type=style&index=0&id=21988fb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports